import React from 'react';
import { ExtendedFlex, Heading } from '../coreui';
import TimelineFiller from './TimelineFiller';
import FadeIn from './FadeIn';

const TimelineContainer = ({ heading, children, ...props }) => {
  const timelineFillerPadding = 30;

  return (
    <ExtendedFlex
      flexDirection="column"
      align={['flex-start', null, 'center']}
      w={1}
    >
      {
        heading &&
        <Heading
          type="H9"
        >
          {heading}
        </Heading>
      }
      <ExtendedFlex
        w={1}
        flexDirection={['column', null, 'row']}
        flexWrap="wrap"
        {...props}
        pl={[timelineFillerPadding, null, 0]}
        position="relative"
        overflowX="hidden"
      >
        <TimelineFiller
          position="absolute"
          left={[timelineFillerPadding, null, '50%']}
          top={0}
          bottom={0}
          zIndex={1}
        />
        {
          React.Children.map(children, (child, i) => {
            return (
              <FadeIn>
                {
                  React.cloneElement(
                    child,
                    {
                      position: i % 2 ? 'second' : 'first',
                    },
                  )
                }
              </FadeIn>
            );
          })
        }
      </ExtendedFlex>
    </ExtendedFlex>
  );
};

export default TimelineContainer;
